module.exports = __webpack_public_path__ + "public/images/stands-contact-1.099fc6c205e8775dfaccce092d253a87.jpg";